import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Avatar, Tooltip } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import { roundMacros, scaleMacros } from "@notemeal/shared-utils-macro-protocol";
import { MacrosSummaryLabel } from "../Macros/SummaryLabel";
const useStyles = makeStyles((theme) => createStyles({
    usdaFavicon: {
        marginRight: theme.spacing(),
        width: 16,
        height: 16,
    },
    flexRow: {
        display: "flex",
        flexDirection: "row",
    },
}));
export const ServingAmountTooltip = ({ children, amount, serving }) => {
    const classes = useStyles();
    const { macros } = serving;
    const scaledMacros = roundMacros(scaleMacros(macros, amount));
    return (_jsx(Tooltip, { PopperProps: {
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: [0, 2],
                    },
                },
            ],
        }, title: _jsxs(_Fragment, { children: [_jsx(MacrosSummaryLabel, { macros: scaledMacros, kcalPrefix: true, variant: "sm" }), _jsx("br", {}), serving.foodOrRecipe.name, _jsx("br", {}), serving.foodOrRecipe.__typename === "GenericFood" && serving.foodOrRecipe.usdaFdcDescription && (_jsxs("span", { className: classes.flexRow, children: [_jsx(Avatar, { variant: "square", className: classes.usdaFavicon, src: "/img/usda_favicon.ico" }), serving.foodOrRecipe.usdaFdcDescription] })), serving.foodOrRecipe.__typename === "Recipe" &&
                    `Created by ${serving.foodOrRecipe.createdBy.firstName} ${serving.foodOrRecipe.createdBy.lastName}`] }), children: children }));
};
//# sourceMappingURL=Tooltip.js.map